// @ts-strict-ignore
import { stripBBTags } from 'src/utils/string';
import i18n from 'src/utils/translate';
import { MAX_CHARS_COMMUNITY_DESCRIPTION, MIN_CHARS_COMMUNITY_DESCRIPTION } from 'src/constants/about';

type ValidateProps = {
  description?: string;
  setIsDirty: (isDirty: boolean) => void,
  setIsSubmitDisabled: (isSubmitDisabled: boolean) => void,
}

export const validateAbout = ({ description, setIsDirty, setIsSubmitDisabled }: ValidateProps): string[] => {
  // emojis count as 2 char.
  const messages = [];
  const cleanText = !!description.length && stripBBTags(description) || '';
  const trimmedText = cleanText.trim();

  if (cleanText.length > 0) {
    setIsDirty(true);
  }

  if (trimmedText.length === 0 || trimmedText.length >= MIN_CHARS_COMMUNITY_DESCRIPTION) {
    setIsSubmitDisabled(false);
  } else {
    setIsSubmitDisabled(true);
  }

  switch (true) {
    case (
      cleanText.length > 0
      && cleanText.length < MIN_CHARS_COMMUNITY_DESCRIPTION
      || trimmedText.length > 0
      && trimmedText.length < MIN_CHARS_COMMUNITY_DESCRIPTION
    ):
      messages.push(i18n.t(`Descriptions must have at least ${MIN_CHARS_COMMUNITY_DESCRIPTION} characters`));
      return messages;
    case cleanText.length > MAX_CHARS_COMMUNITY_DESCRIPTION:
      messages.push(i18n.t(`Descriptions can have up to ${MAX_CHARS_COMMUNITY_DESCRIPTION} characters`));
      return messages;
    default:
      return messages;
  }
};
